import React, { useState } from "react";
import { get, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock } from "@fortawesome/pro-light-svg-icons";
import { usCurrency } from "../../../../utils";
import moment from "moment";

const data = {
  bankFundings: [
    {
      bankName: "Some",
      bankFund: 1000,
    },
    {
      bankName: "Koewe",
      bankFund: 1000,
    },
    {
      bankName: "Kerw",
      bankFund: 1000,
    },
    {
      bankName: "WRwef",
      bankFund: 1000,
    },
  ],
};
const PayeeCard = () => {
  return (
    <div className="transaction-history-payee-inner-box">
      <div className="cash-distribution-transaction-history">
        Cash distribution <span> - Self</span>
      </div>
      <div className="bottom-payee-card">
        <div className="bottom-payee-card-text-main">
          <div className="text-area-payee">Somethy Erlng</div>
          <div className="secondary-text-payee">payment method</div>
        </div>
        <div className="bottom-payee-card-text-main">
          <div className="text-area-payee">Somethy Erlng</div>
          <div className="secondary-text-payee">payment method</div>
        </div>
        <div className="seperator-transaction-history-detail"></div>
        <div className="block-payee">
          <div className="bottom-payee-card-text-main">
            <div className="secondary-text-payee">Somethy Erlng</div>
            <div className="text-area-payee">payment method</div>
          </div>
          <div className="seperator-transaction-history-detail"></div>
          <div className="bottom-payee-card-text-main">
            <div className="secondary-text-payee">Somethy Erlng</div>
            <div className="text-area-payee">payment method</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export const Payee = (props) => {
  return (
    <div className="transaction-history-withdrawal">
      <div className="transaction-history-withdrawal-header">Payee Details</div>

      {[1, 2, 3, 4, 5].map((e) => {
        return <PayeeCard />;
      })}
    </div>
  );
};
